function Footer() {
  return (
    <footer className="bg-navy py-6 text-center">
      <p className="text-slate font-mono text-sm">
        Designed and built by
        <span className="text-green"> Digamber Dwivedi</span>
      </p>
    </footer>
  );
}

export default Footer;